(function() {
  class BundleUpsellPopup {
    constructor() {
      this.init();
    }

    init() {
      this.bindEvents();
    }

    bindEvents() {
      // Open popup buttons
      document.addEventListener('click', (e) => {
        const button = e.target.closest('[data-action="open-bundle-upsell-popup"]');
        if (button) {
          e.preventDefault();
          this.openPopup(button);
        }
      });

      // Color selection
      document.addEventListener('click', (e) => {
        const colorOption = e.target.closest('.bundle-upsell-popup__color-option:not(.soldout)');
        if (colorOption) {
          e.preventDefault();
          this.handleColorChange(colorOption);
        }
      });

      // Size selection
      document.addEventListener('click', (e) => {
        const sizeOption = e.target.closest('.bundle-upsell-popup__size-option:not(.soldout)');
        if (sizeOption) {
          e.preventDefault();
          this.handleSizeChange(sizeOption);
        }
      });

      // Load more variants
      document.addEventListener('click', (e) => {
        if (e.target.matches('.bundle-upsell-popup__load-more')) {
          e.preventDefault();
          this.loadMoreVariants(e.target);
        }
      });

      // Apply button - handled by cross-sell.js
    }

    openPopup(button) {
      const modalId = button.dataset.modal;
      const modal = document.querySelector(modalId);

      if (modal) {
        modal.show(button);
      } else {
        console.error('Bundle upsell popup not found:', modalId);
      }
    }

    handleColorChange(colorOption) {
      const index = colorOption.dataset.index;
      const originalKey = colorOption.dataset.originalKey;
      const productId = colorOption.dataset.productId;
      const productHandle = colorOption.dataset.productHandle;
      const variantId = colorOption.dataset.variantId;
      const image = colorOption.dataset.image;
      const title = colorOption.dataset.title;
      const colorName = colorOption.dataset.colorName;

      // Update active state
      const colorGrid = colorOption.closest('.bundle-upsell-popup__color-grid');
      if (colorGrid) {
        colorGrid.querySelectorAll('.bundle-upsell-popup__color-option').forEach(opt => {
          opt.classList.remove('is-active');
        });
      }
      colorOption.classList.add('is-active');

      // Update product image
      const productImage = document.querySelector(`#upsell-product-image-${originalKey}-${index}`);
      if (productImage) {
        productImage.src = image;
      }

      // Update product title
      const productTitle = document.querySelector(`#upsell-product-title-${originalKey}-${index}`);
      if (productTitle) {
        productTitle.textContent = title;
      }

      // Update color name
      const colorNameElem = document.querySelector(`#upsell-color-name-${originalKey}-${index}`);
      if (colorNameElem) {
        colorNameElem.textContent = colorName;
      }

      // Update parent wrapper data
      const parentWrapper = document.querySelector(`.bundle-upsell-popup__item--${index}`);
      if (parentWrapper) {
        parentWrapper.setAttribute('data-product-id', variantId);
        parentWrapper.setAttribute('data-product-handle', productHandle);
      }

      // Get product JSON and update sizes
      const productJson = document.querySelector(`#upsell-product-json-${originalKey}-${productId}`);
      if (productJson) {
        try {
          const productData = JSON.parse(productJson.textContent);
          this.updateSizes(productData, index, originalKey);
        } catch (e) {
          console.error('Error parsing product JSON:', e);
        }
      }
    }

    updateSizes(productData, index, originalKey) {
      const sizeGrid = document.querySelector(`.bundle-upsell-popup__size-grid[data-parent-index="${index}"][data-original-key="${originalKey}"]`);

      if (!sizeGrid || !productData.variants) return;

      let sizesHtml = '';
      let hasActiveSize = false;
      const currentActiveSize = sizeGrid.querySelector('.bundle-upsell-popup__size-option.is-active');
      const currentSizeValue = currentActiveSize ? currentActiveSize.dataset.value : null;

      productData.variants.forEach(variant => {
        let sizeClasses = 'bundle-upsell-popup__size-option';

        if (!variant.available) {
          sizeClasses += ' soldout';
        }

        // Try to maintain the same size if available
        if (currentSizeValue && variant.option1 === currentSizeValue && variant.available) {
          sizeClasses += ' is-active';
          hasActiveSize = true;

          // Update parent wrapper with this variant
          const parentWrapper = document.querySelector(`.bundle-upsell-popup__item--${index}`);
          if (parentWrapper) {
            parentWrapper.setAttribute('data-product-id', variant.id);
          }

          // Update size label
          const sizeLabel = document.querySelector(`#upsell-size-value-${originalKey}-${index}`);
          if (sizeLabel) {
            sizeLabel.textContent = variant.option1;
          }
        }

        sizesHtml += `<div class="${sizeClasses}"
                           data-variant-id="${variant.id}"
                           data-index="${index}"
                           data-original-key="${originalKey}"
                           data-value="${variant.option1}"
                           ${!variant.available ? 'data-soldout="true"' : ''}>
                        <span>${variant.option1}</span>
                      </div>`;
      });

      sizeGrid.innerHTML = sizesHtml;

      // If no size was set as active, activate the first available one
      if (!hasActiveSize) {
        const firstAvailable = sizeGrid.querySelector('.bundle-upsell-popup__size-option:not(.soldout)');
        if (firstAvailable) {
          firstAvailable.classList.add('is-active');

          const parentWrapper = document.querySelector(`.bundle-upsell-popup__item--${index}`);
          if (parentWrapper) {
            parentWrapper.setAttribute('data-product-id', firstAvailable.dataset.variantId);
          }

          const sizeLabel = document.querySelector(`#upsell-size-value-${originalKey}-${index}`);
          if (sizeLabel) {
            sizeLabel.textContent = firstAvailable.dataset.value;
          }
        }
      }
    }

    handleSizeChange(sizeOption) {
      const index = sizeOption.dataset.index;
      const originalKey = sizeOption.dataset.originalKey;
      const variantId = sizeOption.dataset.variantId;
      const sizeValue = sizeOption.dataset.value;

      // Update active state
      const sizeGrid = sizeOption.closest('.bundle-upsell-popup__size-grid');
      if (sizeGrid) {
        sizeGrid.querySelectorAll('.bundle-upsell-popup__size-option').forEach(opt => {
          opt.classList.remove('is-active');
        });
      }
      sizeOption.classList.add('is-active');

      // Update size label
      const sizeLabel = document.querySelector(`#upsell-size-value-${originalKey}-${index}`);
      if (sizeLabel) {
        sizeLabel.textContent = sizeValue;
      }

      // Update parent wrapper data
      const parentWrapper = document.querySelector(`.bundle-upsell-popup__item--${index}`);
      if (parentWrapper) {
        parentWrapper.setAttribute('data-product-id', variantId);
      }
    }

    loadMoreVariants(button) {
      const parentIndex = button.dataset.parentIndex;
      const originalKey = button.dataset.originalKey;
      const colorGrid = document.querySelector(`.bundle-upsell-popup__color-grid[data-parent-index="${parentIndex}"][data-original-key="${originalKey}"]`);

      if (colorGrid) {
        const hiddenOptions = colorGrid.querySelectorAll('.bundle-upsell-popup__color-option.is-hidden');
        hiddenOptions.forEach(option => {
          option.classList.remove('is-hidden');
        });

        // Hide the load more button
        button.style.display = 'none';
      }
    }
  }

  // Initialize on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      new BundleUpsellPopup();
    });
  } else {
    new BundleUpsellPopup();
  }
})();

